module.exports = __webpack_public_path__ + "img/afbeelding-filterframe.6e7d8ede.png";